import { createSlice } from "@reduxjs/toolkit";
import { DeleteNotification, GetNotifications } from "./notificationActions";

const initialState = {
    notifications: [],
    loading: false,
    openNotificationListModal: false,
    error: null,
    totalRecord: 0,
    notificationCount: 0, // Notification count state
};

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        resetNotificationCount: (state) => {
          state.notificationCount = 0; // Reset notification count
        },
        incrementNotificationCount: (state) => {
          state.notificationCount += 1; // Increment notification count
        },
        openNotificationModal: (state) => {
          state.openNotificationListModal = true; // Open notification modal
        },
        closeNotificationModal: (state) => {
          state.openNotificationListModal = false; // Close notification modal
        },
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(GetNotifications.pending, (state: any) => {
                state.loading = true;
                state.error = null; // Reset error on pending request
            })
            .addCase(GetNotifications.fulfilled, (state: any, action: any) => {
                state.loading = false;
                state.notifications = action.payload.data;
                state.totalRecord = action.payload?.totalRecord || 0;
            })
            .addCase(GetNotifications.rejected, (state: any, action: any) => {
                state.loading = false;
                state.error = action.payload ? action.payload.error : "Failed to load properties";
            });
    },
});


const deleteNotification = createSlice({
    name: 'deleteNotification',
    initialState,
    reducers: {},
    extraReducers: (builder: any) => {
        builder
            .addCase(DeleteNotification.pending, (state: any) => {
                state.loading = true;
                state.error = null; // Reset error on pending request
            })
            .addCase(DeleteNotification.fulfilled, (state: any, action: any) => {
                state.loading = false;

            })
            .addCase(DeleteNotification.rejected, (state: any, action: any) => {
                state.loading = false;
            });
    },
});
export const { resetNotificationCount, incrementNotificationCount, openNotificationModal, closeNotificationModal } = notificationsSlice.actions;
export const notifications = notificationsSlice.reducer;
export const deleteNotificationSlice = deleteNotification.reducer;


